import { api } from '~shared/api/origin';
import type { TEvent } from '~shared/services/eventsInbox/types';

export const eventsApi = api.injectEndpoints({
	endpoints: (build) => ({
		getEvents: build.query<TEvent[], { id: string; sync?: string }>({
			query: ({ id, sync }) => ({
				url: `/events/${id}`,
				params: { sync },
			}),
		}),
	}),
});
